/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Indicates the billing method for the customer. It can either be a `recurring` billing cycle or a `onetime` payment.
 */
export const ProductRequestBillingType = {
  Recurring: "recurring",
  Onetime: "onetime",
} as const;
/**
 * Indicates the billing method for the customer. It can either be a `recurring` billing cycle or a `onetime` payment.
 */
export type ProductRequestBillingType = ClosedEnum<
  typeof ProductRequestBillingType
>;

/** @internal */
export const ProductRequestBillingType$inboundSchema: z.ZodNativeEnum<
  typeof ProductRequestBillingType
> = z.nativeEnum(ProductRequestBillingType);
/** @internal */
export const ProductRequestBillingType$outboundSchema: z.ZodNativeEnum<
  typeof ProductRequestBillingType
> = ProductRequestBillingType$inboundSchema;
